"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _useLazyRef = _interopRequireDefault(require("../useLazyRef"));
var _usePreviousPersistent = _interopRequireDefault(require("../usePreviousPersistent"));
var _Fullscreen = _interopRequireDefault(require("../../utils/Fullscreen"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useFullscreen = function useFullscreen(element) {
  var _a;
  var fullscreen = (0, _useLazyRef.default)(function () {
    return new _Fullscreen.default();
  });
  var _b = (0, _react.useState)(false),
    isFullscreen = _b[0],
    setIsFullscreen = _b[1];
  var previousIsFullscreen = (0, _usePreviousPersistent.default)(isFullscreen, undefined);
  var open = (0, _react.useCallback)(function () {
    var _a, _b;
    if (element) {
      if ((_a = fullscreen.current) === null || _a === void 0 ? void 0 : _a.isSupported()) {
        (_b = fullscreen.current) === null || _b === void 0 ? void 0 : _b.open(element);
      }
      setIsFullscreen(true);
    }
  }, [fullscreen, element]);
  var close = (0, _react.useCallback)(function () {
    var _a, _b;
    if ((_a = fullscreen.current) === null || _a === void 0 ? void 0 : _a.isSupported()) {
      (_b = fullscreen.current) === null || _b === void 0 ? void 0 : _b.close();
    }
    setIsFullscreen(false);
  }, [fullscreen]);
  (0, _react.useEffect)(function () {
    var fullscreenInstance = fullscreen.current;
    var onFullscreenChange = function onFullscreenChange() {
      var _a;
      if (!((_a = fullscreen.current) === null || _a === void 0 ? void 0 : _a.isFullscreen())) {
        close();
      }
    };
    fullscreenInstance === null || fullscreenInstance === void 0 ? void 0 : fullscreenInstance.addListener(onFullscreenChange);
    return function () {
      fullscreenInstance === null || fullscreenInstance === void 0 ? void 0 : fullscreenInstance.removeListener(onFullscreenChange);
    };
  }, [close, element, fullscreen, isFullscreen, previousIsFullscreen]);
  return {
    open: open,
    close: close,
    isFullscreen: isFullscreen,
    isSupported: ((_a = fullscreen.current) === null || _a === void 0 ? void 0 : _a.isSupported()) || false
  };
};
var _default = useFullscreen;
exports.default = _default;